import { fetchUserFiles } from '../api/digitalVault';
export default async (params = {}, logger) => fetchUserFiles(params, 'browse/audio', logger);
